import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateShipmentConfiguration } from '../../store/csw/csw.actions';

export const useExternalFulfillmentServiceState = (fulfillmentPlanId, onConfigurationChange) => {
  const dispatch = useDispatch();
  const onFulfillmentServiceChange = useCallback(
    (newFulfillmentServiceId) => {
      dispatch(
        updateShipmentConfiguration(fulfillmentPlanId, {
          fulfillmentServiceId: newFulfillmentServiceId,
        }),
      );
      onConfigurationChange({ fulfillmentServiceId: newFulfillmentServiceId });
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  return {
    onFulfillmentServiceChange,
  };
};
